module.exports = __webpack_public_path__ + "odinstatic/media/manual-placement.9726886b.svg";